import { render, staticRenderFns } from "./projectDetail.vue?vue&type=template&id=14cd5c22&scoped=true"
import script from "./projectDetail.vue?vue&type=script&lang=ts"
export * from "./projectDetail.vue?vue&type=script&lang=ts"
import style0 from "./projectDetail.vue?vue&type=style&index=0&id=14cd5c22&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14cd5c22",
  null
  
)

export default component.exports